module.exports = __webpack_public_path__ + "img/centrosCostos.3024f85b.svg";